import React, { useEffect, useState, useRef } from 'react';
import './HexagonLoader.css';

/**
 * HexagonLoader Component
 * A continuously animating hexagon loader with a loading indicator.
 * Uses CSS animation-direction: alternate for smooth infinite looping
 * that reverses direction instead of restarting, creating a seamless
 * ping-pong effect without any visual breaks.
 */
const HexagonLoader = () => {
    // State for animated loading dots
    const [loadingDots, setLoadingDots] = useState('');
    // Ref to track if component is mounted for safe interval cleanup
    const isMounted = useRef(true);

    useEffect(() => {
        /**
         * Animates the loading dots indicator (. -> .. -> ... -> .)
         * Updates every 500ms to show user that something is happening.
         */
        const dotsInterval = setInterval(() => {
            if (!isMounted.current) return;
            setLoadingDots(prev => {
                if (prev.length >= 3) return '';
                return prev + '.';
            });
        }, 500);

        // Cleanup on unmount - set isMounted to false and clear interval
        return () => {
            isMounted.current = false;
            clearInterval(dotsInterval);
        };
    }, []);

    return (
        <div className="hexagon-loader-container">
            {/* Hexagon animation container - uses pure CSS animations with alternate direction */}
            <div className="hexagon-loader">
                <div className="hexagon hex-1a group2"></div>
                <div className="hexagon hex-2a group1"></div>
                <div className="hexagon hex-2b group2"></div>
                <div className="hexagon hex-3a group1"></div>
                <div className="hexagon hex-3b group1"></div>
                <div className="hexagon hex-3c group2"></div>
            </div>
            {/* Loading indicator text with animated dots */}
            <div className="loading-indicator">
                <span className="loading-text">Loading</span>
                <span className="loading-dots">{loadingDots}</span>
            </div>
        </div>
    );
};

export default HexagonLoader;